<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <form class="search-box position-relative" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un element"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <div class="d-sm-flex align-items-center">
          <!-- <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            href="#"
            data-bs-toggle="modal"
            data-bs-target="#AddElementModal"
          >
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
            Ajouter un client
        </a> -->
          
          <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
            type="button"
          >
            Export
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  Statut
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  code
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Mt CMD
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Mt DU
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Mise 
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Epargne
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Reserve
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Tranche
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ve, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  
                  <span v-if="isReglementAJour(ve)[0]" class="badge text-bg-success fs-13">
                    A jour
                  </span>
                  <span v-else class="badge text-bg-danger fs-13">
                    Non a jour
                  </span>
                  <!-- {{ isReglementAJour(ve) }} -->
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ index + 1 }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ ve.client.code }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ ve.montant }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ ve.montant - isReglementAJour(ve)[1] }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ ve.mise }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ ve.epargne }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ (isReglementAJour(ve)[1] % ve.mise) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                 {{ Math.floor(isReglementAJour(ve)[1] / ve.mise) }}
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#AddElementModal"
                        @click="getOne(ve.id, ve.client.code)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Détails
                      </a>
                    </li>
                    <!-- <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" @click="suppression(cli.id,elements,'client','ce client')"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1" 
                        ></i>
                        Supprimer
                      </a>
                    </li> -->
                  </ul>
              </div>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>

    <!-- DEBUT MODAL -->

    <div
      class="modal fade createNewModal"
      id="AddElementModal"
      tabindex="-1"
      ref="addElementModalRef"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15" v-if="element.length > 0">
          <!-- <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">Détails des reglements de {{ codeClient }}</h5>
          </div> -->
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <ul class="nav nav-tabs mb-15 mb-md-20" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="overviewPreview-tab" data-bs-toggle="tab" data-bs-target="#overviewPreview-tab-pane" type="button" role="tab" aria-controls="overviewPreview-tab-pane" aria-selected="true"> Commande </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="overviewCode-tab" data-bs-toggle="tab" data-bs-target="#overviewCode-tab-pane" type="button" role="tab" aria-controls="overviewCode-tab-pane" aria-selected="false" tabindex="-1"> Reglements </button>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade active show" id="overviewPreview-tab-pane" role="tabpanel" tabindex="0" aria-labelledby="overviewPreview-tab">
                <div class="table-responsive">
                  <table class="table text-nowrap align-middle mb-0">
                    <!-- <thead>
                      <tr>
                        <th
                          scope="col"
                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-15 pt-0"
                        >
                          Date
                        </th>
                        <th scope="col"
                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-15 pt-0"
                        > Montant
                        </th>
                        <th scope="col"
                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-15 pt-0"
                        > Reste à payer
                        </th>
                      </tr>
                    </thead> -->
                    <tbody>
                      <tr>
                        <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-15">
                          Date vente : 
                        </th>
                        <td>
                          {{ vente ? format_Date(vente.dateVente) : '-' }}
                        </td>
                        <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-15">
                          Client : 
                        </th>
                        <td>
                          {{ vente ? vente.client.nom+ ' '+ vente.client.prenoms : '-' }}
                        </td>
                      </tr>
                      
                      <tr v-for="(pro, indexx) in vente?.prodCondVentes" :key="indexx">
                        <td class="shadow-none lh-1 fw-medium text-paragraph fs-15">
                          {{ indexx + 1 }}
                        </td>
                        <td class="shadow-none lh-1 fw-medium text-paragraph fs-15">
                          {{ pro.nomComplet}}
                        </td>
                        <td class="shadow-none lh-1 fw-medium text-paragraph fs-15">
                          {{ pro.qteVendu }} x {{ pro.prix }}
                        </td>
                        <td class="shadow-none lh-1 fw-medium text-paragraph fs-15">
                          {{ pro ? pro.montant : "-" }}
                        </td>
                      </tr>
                      <tr>
                        <th> Total </th>
                        <td >{{ vente ? vente.montant : "" }}</td>
                        <th> Total Sans Epargne </th>
                        <td >{{ vente ? vente.montantSansEpargne : "" }}</td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
              <div class="tab-pane fade position-relative" id="overviewCode-tab-pane" role="tabpanel" tabindex="0" aria-labelledby="overviewCode-tab">
                
                <!-- TABLES POUR LES REGLEMENTS -->
                <div class="table-responsive">
                  <table class="table text-nowrap align-middle mb-0">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-15 pt-0"
                        >
                          Date
                        </th>
                        <th scope="col"
                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-15 pt-0"
                        > Montant
                        </th>
                        <th scope="col"
                          class="text-uppercase fw-medium shadow-none text-body-tertiary fs-15 pt-0"
                        > Reste à payer
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(e, inde) in element" :key="inde">
                        <td class="shadow-none lh-1 fw-medium text-paragraph fs-15">
                          {{ format_Date(e.dateReglement) }}
                        </td>
                        <td class="shadow-none lh-1 fw-medium text-paragraph fs-15">
                          {{ e.montant}}
                        </td>
                        <td class="shadow-none lh-1 fw-medium text-paragraph fs-15">
                          {{ e.restAPayer }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="text-align: right !important;"> Total Reglement</td>
                        <td> <b> <h6>{{ totalReg }}</h6></b>  </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="text-align: right !important;"> Total Restant Du</td>
                        <td> <b> <h6>{{ vente ? vente.montant - totalReg : "-" }}</h6> </b> </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
            </div>
            

          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-content p-15 p-md-40" v-else >
          <center>
            <h3>
              Aucun reglement pour ce client
            </h3>
          </center>
        </div>
      </div>
    </div>

    <!-- FIN MODAL -->

  </template>
  
  <script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import bootstrap from 'bootstrap';
import { paginationFields } from '../Utilities/paginationFields';
import { error, suppression, format_Date } from '../../utils/utils';
import ApiService from "../../services/ApiService";
import  { Client }  from '../../models/Client';
import { Vente } from '@/models/Vente';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import { Reglement } from '@/models/Reglement';
import AddVente from '../Vente/AddVente.vue';

  export default defineComponent({
    name: "ListeSuiviClient",
    components: {
      PaginationComponent
    },
    setup: () => {

      const elements = ref<Array<Vente>>([])
      const codeClient = ref('');
      const selectedItem = ref(0);
      const element = ref<Array<Reglement>>([])
      const vente = ref<Vente>();
      const totalReg = ref(0);
      const joursFeries = ref([]);

     
      


      // BEGIN PAGINATE
      const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            getAll(page_, limit_);
          } catch (error) {
            //
            
          }
        };
        function rechercher(){
          getAll(page.value, limit.value, searchTerm.value );
        }
      // END PAGINATE

      const recharger = () => {
        getAll();
      };
     

      onMounted(() => {
        getAll();
      })

      function getAll(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`/ventes/nonregler?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          console.log('result', data.data);
          elements.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          // console.log("yes",data.data.data);
        })
        .catch(({ response }) => {
          error(response.data)
        });
      } 

      function getOne(id: number, code: string) {
        return ApiService.get("/reglements/vente/"+id)
        .then(({ data }) => {
          element.value = data.data;
          codeClient.value = code;
          vente.value = elements.value.find(vente => vente.id === id);

          totalReg.value = element.value.reduce((a,b) => {
            return a + parseFloat( b.montant.toString() );
          }, 0);

          console.log('vente', vente);
          // const modalElement = document.getElementById('AddElementModal');
          // if (modalElement) {
          //   const modal = new bootstrap.Modal(modalElement);
          //   modal.show();
          // }
        })
        .catch(({ response }) => {
          console.log('error', response.data);
          error(response.data.message)
        });
      }


      function isReglementAJour(vente) {
        const joursOuvres = [1, 2, 3, 4, 5];

        // Vérifiez que vente.reglements est défini et est un tableau
        if (!vente.reglements || !Array.isArray(vente.reglements)) {
          console.error('vente.reglements is not defined or not an array');
          return [false, 0];
        }

        // const dateDernierReglement = (vente.reglements.length >0) ? new Date(vente.reglements[vente.reglements.length -1].dateReglement) : null;
        const totalReglement = vente.reglements.reduce((acc, reglement) => acc + reglement.montant, 0);
        const dateVente = new Date(vente.dateVente);
        let dateReglement = new Date(dateVente);
        let joursOuvresPasses = 0;

        // Commence à partir du deuxième jour ouvré après la vente
        while (joursOuvresPasses < 2) {
          dateReglement.setDate(dateReglement.getDate() + 1);
          const day = dateReglement.getDay();
          const isJourFerie = joursFeries.value.some(
            jour => new Date(jour).toDateString() === dateReglement.toDateString()
          );

          if (joursOuvres.includes(day) && !isJourFerie) {
            joursOuvresPasses++;
          }
        }

        // Compte les jours ouvrés sans jours fériés à partir du deuxième jour ouvré
        joursOuvresPasses = 0;
        while (dateReglement <= new Date()) {
          const day = dateReglement.getDay();
          const isJourFerie = joursFeries.value.some(
            jour => new Date(jour).toDateString() === dateReglement.toDateString()
          );

          if (joursOuvres.includes(day) && !isJourFerie) {
            joursOuvresPasses++;
          }
          dateReglement.setDate(dateReglement.getDate() + 1);
        }
        const data = [];
        if ( (joursOuvresPasses * vente.mise) <= totalReglement ) {
          return  [true, totalReglement];
        }
        return  [false, totalReglement];

      }

      return { 
        getAll,
        suppression,
        elements,
        element,
        recharger,
        selectedItem,
        isReglementAJour,
        getOne,
        codeClient,
        totalReg,
        vente,

        page,
        totalPages,
        totalElements,
        limit,
        searchTerm,
        handlePaginate,
        rechercher,

        format_Date
      };
    }

  });
  </script>